import styles from "./style.module.scss";
import { CheckOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import PropType from "prop-types";

const LeftSideComponent = ({ setSelected, selected = "account" }) => {
  const { currentUser } = useSelector((state) => ({
    currentUser: state.profile.currentUser,
  }));
  return (
    <div className={styles.leftSideComponent}>
      <div
        className={styles.avatarContainer}
        style={
          currentUser.coverImageUrl
            ? { backgroundImage: `url(${currentUser.coverImageUrl})` }
            : {}
        }
      />
      <div className={styles.thumb}>
        <img src={currentUser?.profileImageUrl} alt="userImage" />
        {currentUser.isVerified && (
        <div className={styles.selected}>
          <CheckOutlined style={{ color: "#C86DD7" }} />
        </div>
      )}
      </div>
      <div className={styles.infoContainer}>
        <p
          className={styles.name}
        >{`${currentUser.firstName} ${currentUser.lastName}`}</p>
        <div className={styles.buttons}>
          <div
            onClick={() => setSelected("profile")}
            className={`${
              selected === "account" ? styles.selected : styles.notSelected
            }`}
          >
            Account
          </div>
          <div
            onClick={() => setSelected("account")}
            className={`${
              selected === "profile" ? styles.selected : styles.notSelected
            }`}
          >
            Profile
          </div>
        </div>
      </div>
    </div>
  );
};

LeftSideComponent.propTypes = {
  setSelected: PropType.func,
  selected: PropType.string,
};

export default LeftSideComponent;
